module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAA7bUf6AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAEzSURBVDhPrZQ9TsNAEIUNRQRHCAfgLqFD2FIkCkv+Lx1yACdn4E5p09CFC4QySBRpzPs2g6U1AcWEJ63GM/PeaHZ210EfTdNcFkVR53m+kt3K7s3i1+SNehwiTkTcaS31PY7j+AoRFr8sywX5qqomJvGhxFzEV4lGFjoK8iq0gW+hA+iAAuaeBPjonGMz2EVR9GsHfcBXkXc3IxVgiAvLDYLNqKatVZIkNxYfBGnH6PnYhmF4bfFB4NTUyRtF9m5ffwA69P/WyfkzYbpaS4sHWZbdK/FgrgedRqj1aK47HXFn3+6Jtfii9ayCt8qPsPjEycPz7glI0/ROge7Gtm17oWs9lWit9YHFJ24UdrBBZ+4BZ7+dL6iIe8W21x9fsazfQR+IJJiJ6P1P8DWbp24GHYLgE+QaylAigSU6AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./app/img/4.png
// module id = 83
// module chunks = 0